import { Link } from "@zestia/gatsby-plugin-react-i18next"
import * as React from "react"

const HeadingAnchor = ({ children, link }) => {
  return (
    <h2>
      <Link className="heading-anchor" to={link}>
        <span className="subtopic-anchor-icon fa fa-link"></span>
      </Link>
      {children}
    </h2>
  )
}

export default HeadingAnchor
